import axios from 'axios';
import {FeatureConfig} from '@/utils/constants/featuresFlag';
import {attachAuthInterceptor} from '@/core/interceptors/authInterceptor';
import {attachErrorInterceptor} from '@/core/interceptors/errorInterceptor';
import {
  shouldUseMock,
  getMockResponse,
  buildEndpoint,
  buildRequestOptions
} from '@/utils/apiClientUtils';
import {logger} from '@/helpers/logger';

// Global error handler singleton
let globalErrorHandler = null;
export const setGlobalErrorHandler = (handler) => {
  globalErrorHandler = handler;
};

const createApiClient = (baseUrlKey) => {
  const baseURL =
    import.meta.env[FeatureConfig[baseUrlKey]] ||
    import.meta.env[FeatureConfig.apiUrl];
  const client = axios.create({baseURL, timeout: 100000});

  attachAuthInterceptor(client);
  attachErrorInterceptor(client);

  return client;
};

const executeRequest = async (config, options, endpoint) => {
  const baseUrlKey = config.baseUrlKey || 'apiUrl';
  const client = createApiClient(baseUrlKey);
  const requestOptions = buildRequestOptions(config, options, endpoint);

  return client(requestOptions)
    .then((response) => {
      // Check for business logic errors (success: false)
      if (
        response?.data &&
        response.status >= 400 &&
        typeof globalErrorHandler === 'function'
      ) {
        /*globalErrorHandler(response.data.message || 'An unknown error occurred.');*/
        // globalErrorHandler('Something went wrong. Please try again.');
      }
      return response.data || response;
    })
    .catch((error) => {
      if (typeof globalErrorHandler === 'function') {
        /*globalErrorHandler(error.message || 'A network error occurred.');*/
        // globalErrorHandler('Something went wrong. Please try again.');
      }
      throw error;
    });
};

export const request = async (config = {}, options = {}, queryParams = '') => {
  // Early return for mocks - prevents any real API calls
  if (shouldUseMock(config)) {
    logger.warn(
      `[apiClient] Using mock data for endpoint: ${config?.endPoint}`
    );
    return await getMockResponse(config);
  }

  const endpoint = buildEndpoint(config, queryParams);

  try {
    return await executeRequest(config, options, endpoint);
  } catch (error) {
    logger.error('[apiClient] Request failed:', error.message);
    throw error;
  }
};
